import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DismissRegular } from '@fluentui/react-icons';
import { Box, Dialog, IconButton, useTheme } from '@mui/material';
import useImagePreviewDialogStyles from './useImagePreviewDialogStyles';
const ImagePreviewDialog = ({ onClose, open, imgSrc, alt }) => {
    const theme = useTheme();
    const { imageStyles, previewImageDialogStyles, dismissIconBtnStyles } = useImagePreviewDialogStyles();
    return (_jsx(Dialog, { onClose: onClose, open: open, sx: previewImageDialogStyles, children: _jsxs(Box, { className: "preview-content-container", display: 'flex', position: 'relative', children: [_jsx(IconButton, { size: 'small', onClick: onClose, sx: dismissIconBtnStyles, children: _jsx(DismissRegular, { fontSize: 20, color: theme.palette.common.black }) }), _jsx("img", { src: imgSrc, alt: alt, style: imageStyles })] }) }));
};
export default ImagePreviewDialog;
